module.exports = __webpack_public_path__ + "img/turismo.0ac636ac.png";